import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Modal from '../../components/Modal'
import { Input } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { getYearGradeTypes } from '../../actions/common'
import { createSchoolYear, updateSchoolYear } from '../../actions/schoolYears'
import Confirmation from '../../components/Confirmation/Confirmation'
import styles from './styles.module.scss'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  begdate: Yup.string().required('обязательное поле'),
  enddate: Yup.string()
    .required('обязательное поле')
    .test('is-after-begdate', 'Дата конца должна быть позже даты начала', function (value) {
      const { begdate } = this.parent
      if (!begdate || !value) return true
      return new Date(value) > new Date(begdate)
    }),
})

export default function SchoolYearsModal({ data, closeModal, width, height }) {

  const dispatch = useDispatch()
  const { yearGradeTypes: yearGradeTypesFromStore } = useSelector(state => state.common)
  const mockGradeTypes = [
    { y_grtype_id: 1, title: 'Год' },
    { y_grtype_id: 2, title: 'Зачет/экзамен' },
    { y_grtype_id: 3, title: 'Итоговая оценка' },
  ]
  const yearGradeTypes = yearGradeTypesFromStore?.length ? yearGradeTypesFromStore : mockGradeTypes

  const addMode = !data?.xp_key

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  useEffect(() => {
    // if (!yearGradeTypes) {
    dispatch(getYearGradeTypes())
    // }
  }, [])

  const handleCreateYear = async (values) => {
    const success = await dispatch(createSchoolYear(values))
    if (success) closeModal()
  }

  const handleUpdateYear = async (values) => {
    const { xp_key, ...payload } = values
    const success = await dispatch(updateSchoolYear(xp_key, payload))
    if (success) closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    setFieldValue,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? { year_grade_types: '', name: '', begdate: '', enddate: '' } : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreateYear : handleUpdateYear
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const selectedIds = values.year_grade_types
    ? values.year_grade_types.split(',').map(Number)
    : []

  const toggleGradeType = (id) => {
    const updated = selectedIds.includes(id)
      ? selectedIds.filter(sid => sid !== id)
      : [...selectedIds, id]
    setFieldValue('year_grade_types', updated.join(','))
  }

  return (
    <Modal open={!!data} width={width} height={height} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='Название'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsRow}>
            <Input
              label='Период (начало)'
              name='begdate'
              type='date'
              error={error('begdate')}
              value={values.begdate}
              onChange={handleChange}
            />
            <Input
              label='Период (конец)'
              name='enddate'
              type='date'
              error={error('enddate')}
              value={values.enddate}
              onChange={handleChange}
            />
          </div>
          <div className={styles.inputsColumn}>
            <p className={styles.checkboxListLabel}>Тип оценок</p>
            <div className={styles.checkboxList}>
              {yearGradeTypes?.map(({ y_grtype_id, title }) => (
                <label key={y_grtype_id} className={styles.checkboxListItem}>
                  <input
                    type='checkbox'
                    checked={selectedIds.includes(y_grtype_id)}
                    onChange={() => toggleGradeType(y_grtype_id)}
                  />
                  <span>{title}</span>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
